// extracted by mini-css-extract-plugin
export default {"card":"Z3-z"};